var voted_users_default = {
  "container": "hTzA8",
  "webview": "DCIxZ",
  "avatar_list": "NjOI4",
  "avatar": "TpMDS",
  "user_avatar": "tj8SL",
  "modal": "EI-qA",
  "voted_users_modal": "zhq9Z",
  "overlay": "qNlUJ",
  "user_card": "RwAww",
  "user_name": "Ut-YZ",
  "voted_users_modal_header": "dPpWK",
  "cta": "JpgKs",
  "close_icon": "NTN9J",
  "title": "_5oQoT",
  "member_list_container": "QM72m",
  "member_list": "_4o170",
  "loader": "zOQR7",
  "anonymous_counter": "Z1Lux",
  "spinner": "cp5kd",
  "spin": "W3AiF"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
